import {
  breakpointSizes,
  getBreakpointDown,
  getBreakpointOnly,
  styleConstants,
} from '@paywithextend/components'
import React from 'react'
import { useDispatch } from 'react-redux'
import CloseButton, {
  CloseButtonDesigns,
} from 'src/components/CloseButton/CloseButton'
import Occlusion from 'src/components/Occlusion/Occlusion'
import { closeModal } from 'src/navigation/Lnk'
import { PopupFadeInAndExpand } from 'src/style/keyframeUtils'
import { css } from 'styled-components'

interface RegisterAccountPopupProps {
  currentPage?: number
}

interface PopupProps {
  className?: string
  noPadding?: boolean
  onScroll?: (e: React.UIEvent<HTMLElement>) => void
  childRef?: (node: HTMLDivElement) => void
  parentRef?: (node: HTMLDivElement) => void
  onClose?: () => void
  registerAccount?: RegisterAccountPopupProps
  buttonId?: string
  hideExit?: boolean
}

const Popup: React.FC<React.PropsWithChildren<PopupProps>> = (
  props,
): React.ReactElement => {
  const dispatch = useDispatch()

  const handleOcclusionClick = (): void => {
    props.onClose?.()
    dispatch(closeModal())
  }

  return (
    <div
      onScroll={props.onScroll}
      ref={props.parentRef}
      css={css`
        z-index: 9;
        position: fixed;
        display: flex;
        flex-direction: column;
        align-items: center;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        overflow: scroll;
      `}
    >
      <Occlusion
        css={css`
          z-index: 0;
        `}
        isOpen={true}
        onClick={(): void => {
          if (!props.hideExit) handleOcclusionClick()
        }}
        fadeIn
      />
      <div
        ref={props.childRef}
        css={css`
          margin: auto;
          padding: 10px;
          position: relative;
          z-index: 1;
          display: flex;
          flex-direction: column;
          flex-shrink: 0;

          ${PopupFadeInAndExpand()}

          ${getBreakpointDown(breakpointSizes.XSM)(css`
            margin: 60px 10px;
            align-self: stretch;
          `)}

          ${getBreakpointOnly(breakpointSizes.XXSM)(css`
            margin: 40px 5px;
          `)}
        `}
      >
        {!props.hideExit && (
          <CloseButton
            css={css`
              margin-bottom: 20px;
              align-self: flex-end;
            `}
            design={CloseButtonDesigns.LightOnDark}
            isRightAligned
            onClick={(): void => {
              handleOcclusionClick()
            }}
            id={props.buttonId || 'closeIcon'}
          />
        )}
        <div
          className={props.className}
          css={css`
            background-color: ${styleConstants.colors.white};
            border-radius: ${styleConstants.borderRadius.box};
            box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
            width: ${styleConstants.widths.popup};
            padding: 60px;
            flex: 1 0 auto;

            ${getBreakpointDown(breakpointSizes.XSM)(css`
              flex-grow: 2;
              width: 100%;
              padding: 40px;
            `)}

            ${getBreakpointOnly(breakpointSizes.XXSM)(css`
              padding: 40px 20px;
            `)}

          ${!!props.noPadding &&
            css`
              padding: 0px;
            `}
          `}
        >
          {props.children}
        </div>
      </div>
    </div>
  )
}

export default Popup
